export default "__VITE_ASSET__Bb9m7V2f__"